export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Details',
    pathname: '/',
    hash: '#details',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'Twitter',
    url: 'https://twitter.com/Kirubak60887066',
    icon: 'twitter',
  },
  {
    label: 'Github',
    url: 'https://github.com/kiruba48',
    icon: 'github',
  },
  {
    label: 'Linkedin',
    url: 'https://linkedin.com/in/kiruba48',
    icon: 'linkedin',
  },
];
